{
  "community":{
    "mlmprefix":"a West African mbira melody with a playful beat",
    "treesprefix":"the resonant rhythm of a West African djembe",
    "treeslowprefix":"calm and dreamy percussions with drumbeats and djembe",
    "pondprefix":"resonant West African percussions with a soothing melody",
    "floorprefix":"playful rhythm of the vibraphone with a clear steady vibrant melody",
    "cloudsprefix":"soft dreamy West African rhythms with flutes",
    "keywords":[
      {
         "keyword":"hope",
         "prompt":"with a hopeful sound",
         "riddle":true
      },
      {
         "keyword":"trust",
         "prompt":"with a comforting sound",
         "riddle":true
      },
      {
         "keyword":"harmony",
         "prompt":"with a soothing calming harmony",
         "riddle":true
      },
      {
         "keyword":"celebration",
         "prompt":"with an upbeat celebratory  sound",
         "riddle":true
      }
    ],
    "dream-prompts":{
      "instruments":{
        "balafon":"mellow nazal buzzing tones of a balafon",
        "mbira":"haunting bell like sounds of a mbira",
        "marimba":"dreamy tones of a marimba",
        "shekere":"crisp sandy sounds of a shekere",
        "slit drum":"deep booming of a slit drum",
        "kora":"drifting mellow kora",
        "dunun":"deep full rhythm of a dunun",
        "shakers":"lively shakers",
        "flute":"airy flute",
        "agogo":"resonant clicking of an agogo",
        "bata":"resonant rhythm of a bata drum",
        "omele":"fast rhythm of a omele drum",
        "djembe":"booming slaps of a djembe",
        "ngoni":"mellow bluesy notes of a ngoni",
        "talking drum":"resonant humming of a talking drum",
        "synthesizers":"the warm electronic beats of a synthesizer",
        "bass":"deep rhythm of an electronic bass",
        "turntables":"warm electronic turntable beats"
      },
      "colors":{
        "possibility":" with an inspiring emotional upbeat sound",
        "experimental":" with an experimental playful sound",
        "hopeful":" with a hopeful joyous sound",
        "joyful":" with a joyful happy beat",
        "risky":" with a suspensful evocative sound",
        "magical":" with a twinkling magical airy sound",
        "empowering":" with a strong moving inspiring bass sound",
        "creative":" with a playful light and creative sound",
        "playful": " with a playful sweet and silly sound",
        "mindful": " with a gentle calming sound",
        "wise": " with a comforting nostalgic sound",
        "reflective": " with a pensive meditative sound",
        "personal":" with an emotional positive sound",
        "optimism":" with an optimistic happy beat",
        "slow":" with a soft slow sound",
        "vibrant":" with an exciting vibrant sounds"
      }
    }
  },
  "spirit":{
    "mlmprefix" : "resonant rhythm of a West African djembe",
    "treesprefix":"with a resonant rhythm of a West African djembe",
    "treeslowprefix":"dreamy and calm West African percussions with slow drumbeats",
    "pondprefix":"with a gentle resonant West African percussion and a soft, soothing melody",
    "floorprefix":"with the playful resonant rhythm of the vibraphone and a clear steady vibrant melody",
    "cloudsprefix":"with a soft dreamy fluffy West African rhythm with flutes",
    "centertreeprefix":"with a gentle resonant West African percussion and a soft, soothing kora and tambin melody",
    "leafprefix":"with flutes that sound like birds",
    "bridgeprefix":"with a rythmic background beat and West African percussions",
    "keywords":[
      {
         "keyword":"progress",
         "prompt":"with a progressive hopeful sound",
         "riddle":true
      },{
         "keyword":"bravery",
         "prompt":"with a resounding deep drumbeat sound",
         "riddle":true
      },{
         "keyword":"motivation",
         "prompt":"with a motivating happy sound",
         "riddle":true
      },{
         "keyword":"resilience",
         "prompt":"with a comforting sound",
         "riddle":true
      }
    ],
    "dream-prompts":{
      "instruments":{
        "balafon":"mellow nazal buzzing tones of a balafon",
        "mbira":"haunting bell like sounds of a mbira",
        "marimba":"dreamy tones of a marimba",
        "shekere":"crisp sandy sounds of a shekere",
        "slit drum":"deep booming of a slit drum",
        "kora":"drifting mellow kora",
        "dunun":"deep full rhythm of a dunun",
        "shakers":"lively shakers",
        "flute":"airy flute",
        "agogo":"resonant clicking of an agogo",
        "bata":"resonant rhythm of a bata drum",
        "omele":"fast rhythm of a omele drum",
        "djembe":"booming slaps of a djembe",
        "ngoni":"mellow bluesy notes of a ngoni",
        "talking drum":"resonant humming of a talking drum",
        "synthesizers":"the warm electronic beats of a synthesizer",
        "bass":"deep rhythm of an electronic bass",
        "turntables":"warm electronic turntable beats"
      },
      "colors":{
        "blue":" with a serene calming harmony",
        "purple":" with a deep resonant beat",
        "red":" with a powerful fast emotional beat",
        "orange":" with a vibrant warm harmony",
        "green" : " with an earthy grounded beat",
        "yellow": " with a happy and warm beat",
        "pink":" with soft romantic harmonies"
      }
    }
  }
}
